// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-04T21:37:37.106Z
// Property: Prosper 207 (ID: 6767906449167863)
// Collections: 10 amenities, 4 floorplans (live), 16 photos, 73 POIs, 5 office hours
// Live collections (fetched at runtime): floorplans, floorplans_full, special_offers, fees

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162469",
  "multihub_property_id": "6767906449167863",
  "property_external_id": "2623136",
  "property_zillow_url": null,
  "property_apartments_url": null,
  "property_google_business_url": "https://www.google.com/maps/place/Prosper+207/@36.2698346,-115.0440301,922m/data=!3m2!1e3!4b1!4m6!3m5!1s0x80c8e7d1291bf123:0x1fa1f8570b8b111a!8m2!3d36.2698346!4d-115.0440301!16s%2Fg%2F11zzy6c43_?entry=ttu&g_ep=EgoyMDI2MTAyMC4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "prosper-207",
  "property_name": "Prosper 207",
  "property_website_url": "https://www.prosper207.com/",
  "property_domain": "https://www.prosper207.com/",
  "property_address": "4345 E Tropical Pkwy",
  "property_full_address": "4345 E Tropical Pkwy, North Las Vegas, NV 89081",
  "property_address_1": "4345 E Tropical Pkwy",
  "property_address_2": null,
  "property_address_city": "North Las Vegas",
  "property_address_state": "NV",
  "property_address_zip_full": "89115",
  "property_address_zip": "89081",
  "property_address_country": "US",
  "property_address_county": "Clark County",
  "property_neighborhood_address": null,
  "property_address_latitude": "36.2693786",
  "property_address_longitude": "-115.0804771",
  "property_email": "prosper207@havenrc.com",
  "property_phone": "(555) 555-5555",
  "property_call_tracking_phone": "725-338-5220",
  "property_company_name": "Haven Realty Capital",
  "property_company_url": "https://www.havenrc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": null,
  "property_long_description": null,
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-27df-7256-84a2-04f2187430d6.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior of apartment buildings with a parking lot and trees.",
    "public_id": "01a16a9d-27df-7256-84a2-04f2187430d6",
    "storage_key": "property/6767906449167863/01a16a9d-27df-7256-84a2-04f2187430d6.webp",
    "width": 3072,
    "height": 1727
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": "350",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": "null",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://homesbyhaven.securecafe.com/onlineleasing/prosper-207-prosper-207-llc/floorplans.aspx",
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9c-4f40-76cb-aa3a-9c4fa6af67b3.webp",
  "property_primary_logo_media": {
    "alt_text": "Prosper 207 logo",
    "public_id": "01a16a9c-4f40-76cb-aa3a-9c4fa6af67b3",
    "storage_key": "property/6767906449167863/01a16a9c-4f40-76cb-aa3a-9c4fa6af67b3.webp",
    "width": 1330,
    "height": 400
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9c-4f48-7569-b52b-cb156b94b0d1.webp",
  "property_secondary_logo_media": {
    "alt_text": "Prosper 207 property logo",
    "public_id": "01a16a9c-4f48-7569-b52b-cb156b94b0d1",
    "storage_key": "property/6767906449167863/01a16a9c-4f48-7569-b52b-cb156b94b0d1.webp",
    "width": 670,
    "height": 720
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9c-4e3d-7592-8266-124f3f49f5a9.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Prosper 207 logo",
    "public_id": "01a16a9c-4e3d-7592-8266-124f3f49f5a9",
    "storage_key": "property/6767906449167863/01a16a9c-4e3d-7592-8266-124f3f49f5a9.webp",
    "width": 1245,
    "height": 350
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9e-5107-737d-9ae0-d70e54798ea8.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a16a9e-5107-737d-9ae0-d70e54798ea8",
    "storage_key": "property/6767906449167863/01a16a9e-5107-737d-9ae0-d70e54798ea8.webp",
    "width": 1280,
    "height": 384
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162469/01a0d005-78c2-763b-8b59-d7ceb837a01b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto/company/5767906449162469/01a03a90-de01-74b6-8003-8a38c8b3b984.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#494e50",
  "property_secondary_color": "#d7d2cb",
  "property_font_color": null,
  "property_color_4": "#635446",
  "property_color_3": "#6f806f",
  "property_color_5": "#b07a63",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": null,
  "property_bedrooms_min": null,
  "property_bedrooms_max": null,
  "property_bathrooms_range": null,
  "property_bathrooms_min": null,
  "property_bathrooms_max": null,
  "property_sqft_range": null,
  "property_sqft_min": null,
  "property_sqft_max": null,
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": null,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJI_EbKdHnyIARGhGLC1f4oR8",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Prosper 207",
  "property_home_romance_title": "Embrace a Beautiful Life in Your New Apartment Home",
  "property_home_amenities_blurb": null,
  "property_home_floorplans_blurb": null,
  "property_home_gallery_blurb": null,
  "property_home_neighborhood_blurb": "<p>Located in northeast North Las Vegas, Prosper 207 offers easy access to recreation, entertainment and everyday essentials. Catch a race or festival at Las Vegas Motor Speedway, spend an afternoon at Craig Ranch Regional Park, or get to Nellis Air Force Base in minutes. With everything you need close by, Prosper 207 provides one of the best apartment living experiences in North Las Vegas, NV.</p>",
  "property_home_reviews_blurb": null,
  "property_neighborhood_blurb": null,
  "property_accessibility_blurb": null,
  "property_amenities_blurb": null,
  "property_applynow_blurb": null,
  "property_contactus_blurb": null,
  "property_faqs_blurb": null,
  "property_floorplans_blurb": null,
  "property_gallery_blurb": null,
  "property_interactivemap_blurb": null,
  "property_pets_blurb": null,
  "property_referafriend_blurb": null,
  "property_residentaccess_blurb": null,
  "property_reviews_blurb": null,
  "property_created_at": "1792621754815",
  "property_scheduletour_blurb": null,
  "property_thankyou_blurb": null,
  "property_virtualtours_blurb": null,
  "property_copyright": null,
  "property_seo_title_home": null,
  "property_seo_description_home": null,
  "property_seo_title_floorplans": "Floor Plans | North Las Vegas, NV Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Prosper 207 in North Las Vegas! Choose from stylish one and two-bedroom floor plans designed for comfort and convenience.",
  "property_seo_title_amenities": null,
  "property_seo_description_amenities": null,
  "property_seo_title_gallery": null,
  "property_seo_description_gallery": null,
  "property_seo_title_virtualtours": "Virtual Tours | Prosper 207 Apartments",
  "property_seo_description_virtualtours": "Step inside Prosper 207 in North Las Vegas! Take a virtual tour of our one- and two-bedroom apartments, and envision your future home today!",
  "property_seo_title_interactivemap": null,
  "property_seo_description_interactivemap": null,
  "property_seo_title_neighborhood": null,
  "property_seo_description_neighborhood": "Experience the vibrant vibe of North Las Vegas at Prosper 207. Uncover local favorites and scenic spots just minutes from our one and two-bedroom homes.",
  "property_seo_title_contact": null,
  "property_seo_description_contact": "Connect with Prosper 207 in North Las Vegas! From cozy one-beds to spacious two-beds, we're ready to answer your leasing questions.",
  "property_seo_title_faqs": null,
  "property_seo_description_faqs": null,
  "property_seo_title_reviews": null,
  "property_seo_description_reviews": null,
  "property_seo_title_applynow": null,
  "property_seo_description_applynow": null,
  "property_seo_title_residentaccess": null,
  "property_seo_description_residentaccess": null,
  "property_seo_title_referafriend": null,
  "property_seo_description_referafriend": null,
  "property_seo_title_scheduletour": null,
  "property_seo_description_scheduletour": null,
  "property_seo_title_privacy": null,
  "property_seo_description_privacy": null,
  "property_seo_title_accessibility": null,
  "property_seo_description_accessibility": null,
  "property_seo_title_sitemap": null,
  "property_seo_description_sitemap": null,
  "property_seo_title_thankyou": null,
  "property_seo_description_thankyou": null,
  "property_seo_title_pets": "Pet Policy | Apartments in North Las Vegas, NV",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793823158339",
  "amenities": [
    {
      "id": "custom_0f9b79cc-cbed-4797-a847-55808a202604",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_31b7b73e-10b4-4524-a0c4-6a8267d84700",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5d62b3cc-67b0-4a89-9d77-fa52bac85ab8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_655168a5-deed-4974-a2ef-91f4fc56b9a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_284a4ac1-dc67-41e5-8706-b38198fe90ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Play Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_521ba600-df71-4063-b6d4-fe8ebca73fb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "external_id": "false",
      "title": "Convenient Access to I-15",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_88d15af6-fa23-4b95-a77c-7870bb23d252",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "external_id": "false",
      "title": "Easy Access to Clark County Route 215",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_726724d0-07ef-4e89-b6b3-9152652752cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "external_id": "false",
      "title": "Close to Las Vegas Boulevard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4019e5fa-cfde-4779-b8e6-84b7823ba9f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "external_id": "false",
      "title": "Minutes from Outdoor Recreation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_011f1377-bf84-4a95-9da1-7ee07c294d6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "external_id": "false",
      "title": "10 Minutes to Nellis Air Force Base",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_c7e8920c-7e70-4d1d-9dd2-d39c4befac8d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-437f-710e-a17c-27b73470ecbf.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and landscaping.",
        "public_id": "01a16a9d-437f-710e-a17c-27b73470ecbf",
        "storage_key": "property/6767906449167863/01a16a9d-437f-710e-a17c-27b73470ecbf.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "View of a sleek, modern apartment building showcasing its exterior architecture, balconies, and surrounding greenery.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with balconies and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d63ff495-7cc4-4467-86ed-6e257c124def",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-428f-76fc-a766-ae2eecd57590.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with a playground and parking spaces.",
        "public_id": "01a16a9d-428f-76fc-a766-ae2eecd57590",
        "storage_key": "property/6767906449167863/01a16a9d-428f-76fc-a766-ae2eecd57590.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Explore the vibrant community spaces at our apartment complex, featuring a modern playground for family fun and convenient parking.",
      "link": "",
      "alt_text": "Apartment building exterior with a playground and parking spaces.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_de403857-9660-4d1b-bd45-35dc78613762",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-44cb-73fc-a183-49954cf12420.webp",
      "image_media": {
        "alt_text": "Modern apartment building entrance with accessible parking in the foreground.",
        "public_id": "01a16a9d-44cb-73fc-a183-49954cf12420",
        "storage_key": "property/6767906449167863/01a16a9d-44cb-73fc-a183-49954cf12420.webp",
        "width": 1474,
        "height": 826
      },
      "title": "Community",
      "description": "Discover sophisticated living at this modern apartment complex. Enjoy convenient amenities and a prime location. Contact us today!",
      "link": "",
      "alt_text": "Modern apartment building entrance with accessible parking in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9264e32e-895a-4486-b0ca-1fe644b184ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-3334-7454-8c79-476040a8c4b6.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a swimming pool and surrounding landscaping.",
        "public_id": "01a16a9d-3334-7454-8c79-476040a8c4b6",
        "storage_key": "property/6767906449167863/01a16a9d-3334-7454-8c79-476040a8c4b6.webp",
        "width": 3072,
        "height": 3072
      },
      "title": "Community",
      "description": "Discover modern living in this expansive apartment complex, featuring a sparkling swimming pool, lush courtyards, and ample parking, all captured from an aerial perspective.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex with a swimming pool and surrounding landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7e8465f5-1054-4e1f-ac6e-96b75b8bdb62",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-371a-7349-a661-06b071d6c2d2.webp",
      "image_media": {
        "alt_text": "Woman running on treadmill in apartment complex gym",
        "public_id": "01a16a9d-371a-7349-a661-06b071d6c2d2",
        "storage_key": "property/6767906449167863/01a16a9d-371a-7349-a661-06b071d6c2d2.webp",
        "width": 2000,
        "height": 1273
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring modern cardio equipment for your convenience.",
      "link": "",
      "alt_text": "Woman running on treadmill in apartment complex gym",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b804367e-0231-4237-9770-aa93b1980857",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-2d17-7322-b8e1-29ca91e09dce.webp",
      "image_media": {
        "alt_text": "Cozy living room with a sofa, throw blanket, and decorative pillows.",
        "public_id": "01a16a9d-2d17-7322-b8e1-29ca91e09dce",
        "storage_key": "property/6767906449167863/01a16a9d-2d17-7322-b8e1-29ca91e09dce.webp",
        "width": 2000,
        "height": 1273
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed living space. Features a plush sofa, soft throw blanket, and stylish decorative pillows for ultimate relaxation.",
      "link": "",
      "alt_text": "Cozy living room with a sofa, throw blanket, and decorative pillows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7c8b55ce-120d-4c62-9a01-f16cddf8402f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-27df-7256-84a2-04f2187430d6.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with a parking lot and trees.",
        "public_id": "01a16a9d-27df-7256-84a2-04f2187430d6",
        "storage_key": "property/6767906449167863/01a16a9d-27df-7256-84a2-04f2187430d6.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Community",
      "description": "Exterior view of modern apartment buildings, showcasing the architecture and surrounding landscape with a parking lot and trees.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with a parking lot and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c5c96553-a0b8-4709-ae88-bd881cf5db8a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-2770-7431-a0cb-7f6186d84ccb.webp",
      "image_media": {
        "alt_text": "Three friends enjoying a meal at a restaurant, laughing and eating.",
        "public_id": "01a16a9d-2770-7431-a0cb-7f6186d84ccb",
        "storage_key": "property/6767906449167863/01a16a9d-2770-7431-a0cb-7f6186d84ccb.webp",
        "width": 2000,
        "height": 1273
      },
      "title": "Lifestyle",
      "description": "Friends enjoying a meal together at a trendy restaurant, sharing food and drinks for a fun dining experience.",
      "link": "",
      "alt_text": "Three friends enjoying a meal at a restaurant, laughing and eating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c32853db-5a5a-4973-a410-1dc5adae028d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-2072-75e6-bc41-2e3447225d9c.webp",
      "image_media": {
        "alt_text": "A joyful couple looking at a tablet together on a couch.",
        "public_id": "01a16a9d-2072-75e6-bc41-2e3447225d9c",
        "storage_key": "property/6767906449167863/01a16a9d-2072-75e6-bc41-2e3447225d9c.webp",
        "width": 2000,
        "height": 1273
      },
      "title": "Lifestyle",
      "description": "Happy couple enjoying time together on the couch, sharing a laugh while looking at a tablet.",
      "link": "",
      "alt_text": "A joyful couple looking at a tablet together on a couch.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e3a111af-38a3-4796-9e9c-7b08f9dd74a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-13d0-710a-a348-adb677eaecbd.webp",
      "image_media": {
        "alt_text": "A desk with a laptop and plant bathed in sunlight",
        "public_id": "01a16a9d-13d0-710a-a348-adb677eaecbd",
        "storage_key": "property/6767906449167863/01a16a9d-13d0-710a-a348-adb677eaecbd.webp",
        "width": 2000,
        "height": 1273
      },
      "title": "Apartment",
      "description": "Create your perfect home office setup with a desk, laptop, and lush plant bathed in warm sunlight.",
      "link": "",
      "alt_text": "A desk with a laptop and plant bathed in sunlight",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9d82d32f-2ee6-4bd3-903c-333006672dea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-11eb-7242-96ee-29323a68a897.webp",
      "image_media": {
        "alt_text": "Two happy border collies sitting on grass with mouths open",
        "public_id": "01a16a9d-11eb-7242-96ee-29323a68a897",
        "storage_key": "property/6767906449167863/01a16a9d-11eb-7242-96ee-29323a68a897.webp",
        "width": 2000,
        "height": 1273
      },
      "title": "Community",
      "description": "Two adorable border collies enjoy playtime on the community grounds, showcasing our pet-friendly atmosphere.",
      "link": "",
      "alt_text": "Two happy border collies sitting on grass with mouths open",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5178e76f-c84c-4a01-b698-12f395e31886",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-08b1-72d8-98ff-815086131293.webp",
      "image_media": {
        "alt_text": "Person relaxing in bed with a cat on their lap, a book, and a cup of coffee.",
        "public_id": "01a16a9d-08b1-72d8-98ff-815086131293",
        "storage_key": "property/6767906449167863/01a16a9d-08b1-72d8-98ff-815086131293.webp",
        "width": 2000,
        "height": 1273
      },
      "title": "Lifestyle",
      "description": "Enjoy a peaceful moment of relaxation in your apartment, complete with a furry friend, a good book, and a warm cup of coffee.",
      "link": "",
      "alt_text": "Person relaxing in bed with a cat on their lap, a book, and a cup of coffee.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5b25e904-53b9-4c8e-a320-0a462ee700aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-07b7-743f-8e4d-6b13ad926272.webp",
      "image_media": {
        "alt_text": "People toasting with glasses of red wine, celebrating an occasion.",
        "public_id": "01a16a9d-07b7-743f-8e4d-6b13ad926272",
        "storage_key": "property/6767906449167863/01a16a9d-07b7-743f-8e4d-6b13ad926272.webp",
        "width": 2000,
        "height": 1273
      },
      "title": "Lifestyle",
      "description": "Enjoy a toast with friends and family. Experience the good life at our community.",
      "link": "",
      "alt_text": "People toasting with glasses of red wine, celebrating an occasion.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_66afd3c9-6da3-431d-8252-50cf7d545413",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-04ad-7118-9806-930d9075a0a6.webp",
      "image_media": {
        "alt_text": "Five friends sit on a ridge overlooking a mountain range, sharing photos.",
        "public_id": "01a16a9d-04ad-7118-9806-930d9075a0a6",
        "storage_key": "property/6767906449167863/01a16a9d-04ad-7118-9806-930d9075a0a6.webp",
        "width": 2000,
        "height": 1273
      },
      "title": "Lifestyle",
      "description": "Enjoy the adventurous spirit of our community with friends, surrounded by breathtaking mountain views.",
      "link": "",
      "alt_text": "Five friends sit on a ridge overlooking a mountain range, sharing photos.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a465856a-7ca2-4dda-899a-f5a794cb50d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9c-fee4-74ce-ae37-8db5bf92d8a7.webp",
      "image_media": {
        "alt_text": "Man relaxing on a couch listening to music",
        "public_id": "01a16a9c-fee4-74ce-ae37-8db5bf92d8a7",
        "storage_key": "property/6767906449167863/01a16a9c-fee4-74ce-ae37-8db5bf92d8a7.webp",
        "width": 2000,
        "height": 1273
      },
      "title": "Lifestyle",
      "description": "Enjoy your downtime in a comfortable and stylish living space. This image captures the essence of relaxation and modern living.",
      "link": "",
      "alt_text": "Man relaxing on a couch listening to music",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_52978d29-dc95-4a94-8181-2c3192557302",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9c-fc2b-761e-8fcb-cf2745fc0bd8.webp",
      "image_media": {
        "alt_text": "Couple enjoying cocktails in a swimming pool at sunset.",
        "public_id": "01a16a9c-fc2b-761e-8fcb-cf2745fc0bd8",
        "storage_key": "property/6767906449167863/01a16a9c-fc2b-761e-8fcb-cf2745fc0bd8.webp",
        "width": 2000,
        "height": 1273
      },
      "title": "Lifestyle",
      "description": "Relax and unwind by the pool with a refreshing drink. Our resort-style amenities offer the perfect escape.",
      "link": "",
      "alt_text": "Couple enjoying cocktails in a swimming pool at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_ef09c8aa-10a9-40dd-ad2b-28f555ae23c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "MRKT",
      "poi_type": "Restaurants",
      "poi_address": "7300 N Aliante Pkwy, North Las Vegas, NV 89084, USA",
      "poi_short_description": "Stylish steakhouse in the Aliante Hotel offering meat & seafood & hosting weekend-night music.",
      "poi_long_description": "Stylish steakhouse in the Aliante Hotel offering meat & seafood & hosting weekend-night music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-b75a-707c-a23d-08d872ec058c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-b75a-707c-a23d-08d872ec058c",
        "storage_key": "property/6767906449167863/01a1609f-b75a-707c-a23d-08d872ec058c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://aliante.boydgaming.com/dine/mrkt",
      "poi_directions_map_url": "https://maps.google.com/?cid=10449594452258598079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mrkt",
      "poi_latitude": "36.2931835",
      "poi_longitude": "-115.181072",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 702-692-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7765-748c-96ac-55ffb0ad8d9d",
        "storage_key": "property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN-nO81rpyIARvyzEPcpqBJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_8b1283c3-41be-4f5c-b01f-0f1789b0dc9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "The Salted Lime",
      "poi_type": "Restaurants",
      "poi_address": "7300 N Aliante Pkwy, North Las Vegas, NV 89084, USA",
      "poi_short_description": "Mexican restaurant and tequila bar serving authentic fare and signature margaritas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-b290-722d-b63d-48f4213d46d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-b290-722d-b63d-48f4213d46d7",
        "storage_key": "property/6767906449167863/01a1609f-b290-722d-b63d-48f4213d46d7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://aliante.boydgaming.com/dine/the-salted-lime-al",
      "poi_directions_map_url": "https://maps.google.com/?cid=2462542705656859286&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-salted-lime",
      "poi_latitude": "36.2919853",
      "poi_longitude": "-115.18066779999998",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 702-692-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7765-748c-96ac-55ffb0ad8d9d",
        "storage_key": "property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVYgtTFrpyIARlgroLou1LCI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_f10d7540-bbad-4d38-a699-5d1661fcc146",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Aliante Casino Hotel Spa",
      "poi_type": "Entertainment",
      "poi_address": "7300 N Aliante Pkwy, North Las Vegas, NV 89084, USA",
      "poi_short_description": "Modern desert property offering mountain views, plus a spa, a movie theater & a bingo hall.",
      "poi_long_description": "Modern desert property offering mountain views, plus a spa, a movie theater & a bingo hall.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-acf6-7686-a4ab-d2ac42acd32b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-acf6-7686-a4ab-d2ac42acd32b",
        "storage_key": "property/6767906449167863/01a1609f-acf6-7686-a4ab-d2ac42acd32b.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "https://aliante.boydgaming.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9923839156661073182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aliante-casino-hotel-spa",
      "poi_latitude": "36.2919766",
      "poi_longitude": "-115.1805099",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 702-692-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a160a0-0118-7629-ae54-335bb948dcac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a160a0-0118-7629-ae54-335bb948dcac",
        "storage_key": "property/6767906449167863/01a160a0-0118-7629-ae54-335bb948dcac.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN-nO81rpyIARHjXlXCKPuIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_87acc128-ea05-48d3-af38-b3d5f163e3cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Trattoria 57",
      "poi_type": "Restaurants",
      "poi_address": "7300 N Aliante Pkwy, North Las Vegas, NV 89084, USA",
      "poi_short_description": "Welcoming Italian restaurant serving flavorful pasta dishes and signature chicken specialties.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-b234-744f-82b9-50534eb97ed4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-b234-744f-82b9-50534eb97ed4",
        "storage_key": "property/6767906449167863/01a1609f-b234-744f-82b9-50534eb97ed4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://aliante.boydgaming.com/dine/trattoria-57-al",
      "poi_directions_map_url": "https://maps.google.com/?cid=4079243105006285797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trattoria-57",
      "poi_latitude": "36.29317030000001",
      "poi_longitude": "-115.17909659999998",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 702-692-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7765-748c-96ac-55ffb0ad8d9d",
        "storage_key": "property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtbMiUlrpyIAR5XNcwv1hnDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_dba4cc9e-f4b9-40b5-b530-458afc27cbe0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Waffles Café",
      "poi_type": "Restaurants",
      "poi_address": "6885 N Aliante Pkwy #103, North Las Vegas, NV 89084, USA",
      "poi_short_description": "Easygoing place known for customizable waffles, sandwiches & specialty drinks such as bubble tea.",
      "poi_long_description": "Easygoing place known for customizable waffles, sandwiches & specialty drinks such as bubble tea.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-b295-74c5-87d0-a99ba0461de3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-b295-74c5-87d0-a99ba0461de3",
        "storage_key": "property/6767906449167863/01a1609f-b295-74c5-87d0-a99ba0461de3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://wafflescafe.vegas/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=17255266204253492555&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "waffles-caf",
      "poi_latitude": "36.2856501",
      "poi_longitude": "-115.1789444",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 702-655-7878",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7765-748c-96ac-55ffb0ad8d9d",
        "storage_key": "property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcS8UG13pyIARSxVVwTAFd-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_08c56b6e-cc1e-425b-af3d-7e68407b01c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Rivas Mexican Grill #3",
      "poi_type": "Restaurants",
      "poi_address": "6885 N Aliante Pkwy, North Las Vegas, NV 89084, USA",
      "poi_short_description": "Authentic Mexican restaurant serving fresh breakfast burritos and carne asada fries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-b0a7-73b8-9d1f-15196e035bb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-b0a7-73b8-9d1f-15196e035bb5",
        "storage_key": "property/6767906449167863/01a1609f-b0a7-73b8-9d1f-15196e035bb5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rivasmexicangrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2268461277383098585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rivas-mexican-grill-3",
      "poi_latitude": "36.2858582",
      "poi_longitude": "-115.1791121",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 702-586-2251",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7765-748c-96ac-55ffb0ad8d9d",
        "storage_key": "property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0alIDV3pyIAR2QAmUYMxex8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_6ccd2dca-6137-405c-9c17-5f1fffd00da6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Rocco's New York Pizza",
      "poi_type": "Restaurants",
      "poi_address": "6885 N Aliante Pkwy, North Las Vegas, NV 89084, USA",
      "poi_short_description": "Laid-back spot serving up traditional NYC-style pies, pasta & sandwiches for dine-in or delivery.",
      "poi_long_description": "Laid-back spot serving up traditional NYC-style pies, pasta & sandwiches for dine-in or delivery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-b689-772d-9466-387a5727dbf9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-b689-772d-9466-387a5727dbf9",
        "storage_key": "property/6767906449167863/01a1609f-b689-772d-9466-387a5727dbf9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.roccospizzalv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5086070148466231784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roccos-new-york-pizza",
      "poi_latitude": "36.2859507",
      "poi_longitude": "-115.179275",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 702-459-2229",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7765-748c-96ac-55ffb0ad8d9d",
        "storage_key": "property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcS8UG13pyIAR6EkMVtpZlUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_3b245be8-d7fa-40f7-8935-a79fd1613a52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "CHINA kITCHEN",
      "poi_type": "Restaurants",
      "poi_address": "6885 N Aliante Pkwy #104, North Las Vegas, NV 89084, USA",
      "poi_short_description": "Casual spot for familiar Chinese eats, plus fusion items such as teriyaki rice bowls.",
      "poi_long_description": "Casual spot for familiar Chinese eats, plus fusion items such as teriyaki rice bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-ae68-754d-9011-cd4ce7deaf20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-ae68-754d-9011-cd4ce7deaf20",
        "storage_key": "property/6767906449167863/01a1609f-ae68-754d-9011-cd4ce7deaf20.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chinakitchenorthnv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18025642705216750098&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "china-kitchen",
      "poi_latitude": "36.286143",
      "poi_longitude": "-115.1793647",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 702-644-5858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7765-748c-96ac-55ffb0ad8d9d",
        "storage_key": "property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAzERG13pyIAREkKOVInyJ_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "meal_takeaway"
    },
    {
      "id": "custom_bf9b9fd4-4396-4f46-a925-ecdf347e456f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Moko Sushi",
      "poi_type": "Restaurants",
      "poi_address": "2760 Deer Springs Way #101, North Las Vegas, NV 89084, USA",
      "poi_short_description": "Japanese restaurant featuring all-you-can-eat sushi and fresh rolls.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-b16a-7370-abee-3037df7bb49b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-b16a-7370-abee-3037df7bb49b",
        "storage_key": "property/6767906449167863/01a1609f-b16a-7370-abee-3037df7bb49b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://mokosushilv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10522316992884538930&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moko-sushi",
      "poi_latitude": "36.2842869",
      "poi_longitude": "-115.1786893",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 702-208-9188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7765-748c-96ac-55ffb0ad8d9d",
        "storage_key": "property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLXc4TNnpyIARMn7wLo7HBpI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_0d8e741a-c15c-49f3-b715-7809e2c34b19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Roberto's Taco Shop",
      "poi_type": "Restaurants",
      "poi_address": "1311 W Craig Rd, North Las Vegas, NV 89032, USA",
      "poi_short_description": "Enduring counter-serve chain restaurant with a menu of down-home Mexican plates.",
      "poi_long_description": "Enduring counter-serve chain restaurant with a menu of down-home Mexican plates.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-af8b-7639-8335-61f7abc70eb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-af8b-7639-8335-61f7abc70eb1",
        "storage_key": "property/6767906449167863/01a1609f-af8b-7639-8335-61f7abc70eb1.webp",
        "width": 1207,
        "height": 586
      },
      "poi_business_url": "http://www.robertostacoshop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2208553026105103887&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robertos-taco-shop",
      "poi_latitude": "36.2379098",
      "poi_longitude": "-115.1594665",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 702-633-0373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7765-748c-96ac-55ffb0ad8d9d",
        "storage_key": "property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ5D-qtzpyIARD9abnEZbph4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_c8f6cb25-327c-418d-9de9-228611fd5a6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Buffalo Wild Wings",
      "poi_type": "Restaurants",
      "poi_address": "190 W Craig Rd, North Las Vegas, NV 89032, USA",
      "poi_short_description": "Chain dishing up wings, tenders & burgers, plus sauces ranging from sweet to very spicy.",
      "poi_long_description": "Chain dishing up wings, tenders & burgers, plus sauces ranging from sweet to very spicy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-b810-75f9-a604-4515f84733a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-b810-75f9-a604-4515f84733a5",
        "storage_key": "property/6767906449167863/01a1609f-b810-75f9-a604-4515f84733a5.webp",
        "width": 1200,
        "height": 675
      },
      "poi_business_url": "http://www.buffalowildwings.com/locations/us/nv/north-las-vegas/190-west-craig-road/sports-bar-150?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAxNjYxMjE4Mi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=539383211456964706&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buffalo-wild-wings",
      "poi_latitude": "36.2400614",
      "poi_longitude": "-115.1422648",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 702-642-0055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7765-748c-96ac-55ffb0ad8d9d",
        "storage_key": "property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Qw2xdLpyIARYqizTCxGfAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    },
    {
      "id": "custom_447a8c5d-ea2a-4325-a4ab-ba4395931136",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "BJ's Restaurant & Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "985 E Craig Rd, North Las Vegas, NV 89030, USA",
      "poi_short_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_long_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-ba8e-7489-b07c-6bf61a5d35c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-ba8e-7489-b07c-6bf61a5d35c9",
        "storage_key": "property/6767906449167863/01a1609f-ba8e-7489-b07c-6bf61a5d35c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bjsrestaurants.com/locations/nv/craig-road",
      "poi_directions_map_url": "https://maps.google.com/?cid=12630790704039706766&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bjs-restaurant--brewhouse",
      "poi_latitude": "36.2392665",
      "poi_longitude": "-115.1286836",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 725-433-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7765-748c-96ac-55ffb0ad8d9d",
        "storage_key": "property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm-UFa1zpyIARjsCXejmVSa8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_c4b31be4-ca99-4353-a3e6-fab79dff2193",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "1520 E Craig Rd, North Las Vegas, NV 89030, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-ba65-71d6-8b28-45e86c19ad71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-ba65-71d6-8b28-45e86c19ad71",
        "storage_key": "property/6767906449167863/01a1609f-ba65-71d6-8b28-45e86c19ad71.webp",
        "width": 1280,
        "height": 732
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/nv/north-las-vegas/1520-e-craig-rd?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=204567&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=17398836196960034354&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "36.2402479",
      "poi_longitude": "-115.124103",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 702-430-7884",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a160a0-0118-7629-ae54-2b1ecc650478.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a160a0-0118-7629-ae54-2b1ecc650478",
        "storage_key": "property/6767906449167863/01a160a0-0118-7629-ae54-2b1ecc650478.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ5dLIZQTpyIARMt4CkVYVdfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_cf149a62-06a9-40cc-8212-402e2647b3fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "EllaEm's Soul Food",
      "poi_type": "Restaurants",
      "poi_address": "775 W Craig Rd, North Las Vegas, NV 89032, USA",
      "poi_short_description": "Cozy go-to lures locals for hearty soul food, including fried chicken, catfish & homestyle sides.",
      "poi_long_description": "Cozy go-to lures locals for hearty soul food, including fried chicken, catfish & homestyle sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-ba0f-72cf-a7eb-8bb48a56d748.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-ba0f-72cf-a7eb-8bb48a56d748",
        "storage_key": "property/6767906449167863/01a1609f-ba0f-72cf-a7eb-8bb48a56d748.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://www.ellaems.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16136203723617405755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ellaems-soul-food",
      "poi_latitude": "36.2381524",
      "poi_longitude": "-115.1522095",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 702-823-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7765-748c-96ac-55ffb0ad8d9d",
        "storage_key": "property/6767906449167863/01a16095-7765-748c-96ac-55ffb0ad8d9d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdY8KUNDpyIAROwuNGctP798",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "soul_food_restaurant"
    },
    {
      "id": "custom_348f8aef-0f55-479a-a3d0-085acb480376",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Green Valley Grocery #72",
      "poi_type": "Shopping & Retail",
      "poi_address": "2800 E Tropical Pkwy #100, North Las Vegas, NV 89081, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-bc77-74bc-98c0-7b12d15171fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-bc77-74bc-98c0-7b12d15171fc",
        "storage_key": "property/6767906449167863/01a1609f-bc77-74bc-98c0-7b12d15171fc.webp",
        "width": 1280,
        "height": 459
      },
      "poi_business_url": "http://www.gvgrocery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9014038796299439998&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "green-valley-grocery-72",
      "poi_latitude": "36.2689442",
      "poi_longitude": "-115.1108619",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 702-897-2475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a160a0-0130-727d-9dbb-67004a1b0370.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a160a0-0130-727d-9dbb-67004a1b0370",
        "storage_key": "property/6767906449167863/01a160a0-0130-727d-9dbb-67004a1b0370.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJIQkRGmzpyIARfo8E3YZMGH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_c6a6c847-5d5e-4d71-9795-03a23048d0db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Terribleś",
      "poi_type": "Shopping & Retail",
      "poi_address": "4280 E Tropical Pkwy, North Las Vegas, NV 89081, USA",
      "poi_short_description": "Gas-station & convenience-store chain offering grocery items, snacks & fountain drinks.",
      "poi_long_description": "Gas-station & convenience-store chain offering grocery items, snacks & fountain drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-bf24-7788-a03b-2e025f2de9ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-bf24-7788-a03b-2e025f2de9ea",
        "storage_key": "property/6767906449167863/01a1609f-bf24-7788-a03b-2e025f2de9ea.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.terribles.com/carwash/locations/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1413027161696265548&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "terrible",
      "poi_latitude": "36.2698302",
      "poi_longitude": "-115.0809277",
      "poi_miles_from_property": "0.07",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a160a0-0130-727d-9dbb-67004a1b0370.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a160a0-0130-727d-9dbb-67004a1b0370",
        "storage_key": "property/6767906449167863/01a160a0-0130-727d-9dbb-67004a1b0370.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJG59dQcPnyIARTGXijrcUnBM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_bd5af885-e79f-425a-90b7-625e870c01fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "5940 Losee Rd, North Las Vegas, NV 89081, USA",
      "poi_short_description": "Convenient grocery store ideal for quick shopping trips.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-bde9-7008-b416-fff8011959d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-bde9-7008-b416-fff8011959d7",
        "storage_key": "property/6767906449167863/01a1609f-bde9-7008-b416-fff8011959d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/4339-north-las-vegas-nv/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13464723727136835753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "36.267641399999995",
      "poi_longitude": "-115.115449",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 702-639-1202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-77a8-715a-8e92-806fa0a4e3e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-77a8-715a-8e92-806fa0a4e3e7",
        "storage_key": "property/6767906449167863/01a16095-77a8-715a-8e92-806fa0a4e3e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ0VQbmDoyIARqcjDAuRO3Lo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4a389d37-ac3b-43b8-9afb-aa3ef3040ab5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "565 E Centennial Pkwy, North Las Vegas, NV 89081, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-bd9a-77d7-b64a-c78d9ddeed14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-bd9a-77d7-b64a-c78d9ddeed14",
        "storage_key": "property/6767906449167863/01a1609f-bd9a-77d7-b64a-c78d9ddeed14.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-565+e+centennial+pkwy-north+las+vegas-nv-89081/id=10190",
      "poi_directions_map_url": "https://maps.google.com/?cid=8131870637867326526&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "36.2757113",
      "poi_longitude": "-115.1341733",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 702-399-3405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7787-7121-8457-f0ba674ae9ff",
        "storage_key": "property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ39QrwvjoyIARPtyCuUI12nA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_a01d887e-073a-417a-a402-49c5d47d8145",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "7285 N Aliante Pkwy, North Las Vegas, NV 89084, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-bf9c-745f-a8f0-7fbeecf2a33d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-bf9c-745f-a8f0-7fbeecf2a33d",
        "storage_key": "property/6767906449167863/01a1609f-bf9c-745f-a8f0-7fbeecf2a33d.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/north-las-vegas-nv-pharmacies/7285-aliante-pkwy-north-las-vegas-nv-89084/storeid=7251?WT.mc_id=LS_GOOGLE_RX_7251",
      "poi_directions_map_url": "https://maps.google.com/?cid=6568664492378470308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "36.2927416",
      "poi_longitude": "-115.1849343",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 702-642-0641",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a160a0-0118-7629-ae54-2d9c65e0cd0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a160a0-0118-7629-ae54-2d9c65e0cd0a",
        "storage_key": "property/6767906449167863/01a160a0-0118-7629-ae54-2d9c65e0cd0a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF8kw21npyIARpLfwtI2VKFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_76d7019f-5846-4112-ae6e-810d90f66e74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "2650 E Craig Rd, North Las Vegas, NV 89030, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-bf2a-7349-a8ec-b44ba0397ac2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-bf2a-7349-a8ec-b44ba0397ac2",
        "storage_key": "property/6767906449167863/01a1609f-bf2a-7349-a8ec-b44ba0397ac2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/4974-las-vegas-nv",
      "poi_directions_map_url": "https://maps.google.com/?cid=7412712970649726266&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "36.2422447",
      "poi_longitude": "-115.1137008",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 702-399-9050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7783-756c-99f2-01e35fe7e0f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7783-756c-99f2-01e35fe7e0f5",
        "storage_key": "property/6767906449167863/01a16095-7783-756c-99f2-01e35fe7e0f5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNRpj6h7oyIAROu2BLSw_32Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_c546d05a-e8a8-4760-b069-67e9507533ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Smith's",
      "poi_type": "Shopping & Retail",
      "poi_address": "6855 N Aliante Pkwy, North Las Vegas, NV 89084, USA",
      "poi_short_description": "Typical supermaket carrying produce, meat & pantry staples, along with beer & liquor.",
      "poi_long_description": "Typical supermaket carrying produce, meat & pantry staples, along with beer & liquor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-4347-768b-92c0-02de8d742bb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a16095-4347-768b-92c0-02de8d742bb1",
        "storage_key": "property/6767906449167863/01a16095-4347-768b-92c0-02de8d742bb1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.smithsfoodanddrug.com/stores/grocery/nv/north-las-vegas/6855-aliante-pkwy-no-las-vegas-nv/706/00338?cid=loc_70600338_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=2677604286545388665&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smiths",
      "poi_latitude": "36.2850131",
      "poi_longitude": "-115.1790816",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 702-642-3350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-77a8-715a-8e92-806fa0a4e3e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-77a8-715a-8e92-806fa0a4e3e7",
        "storage_key": "property/6767906449167863/01a16095-77a8-715a-8e92-806fa0a4e3e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ9czZl3pyIAReeSZfOnCKCU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_76b35516-d706-4ce7-ae2c-c3e76af7febe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6506 Losee Rd, North Las Vegas, NV 89086, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-c10b-71f0-ab99-d50e7330fe7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-c10b-71f0-ab99-d50e7330fe7b",
        "storage_key": "property/6767906449167863/01a1609f-c10b-71f0-ab99-d50e7330fe7b.webp",
        "width": 1280,
        "height": 1144
      },
      "poi_business_url": "https://www.sprouts.com/store/nv/north-las-vegas/losee-rd/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2275799849004901742&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "36.278034",
      "poi_longitude": "-115.115463",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 702-857-6362",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-77a8-715a-8e92-806fa0a4e3e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-77a8-715a-8e92-806fa0a4e3e7",
        "storage_key": "property/6767906449167863/01a16095-77a8-715a-8e92-806fa0a4e3e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMddRRKnpyIARbiXTq-dDlR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b5abd8a1-77dc-4990-b128-ee9b20e9d6fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Shell",
      "poi_type": "Transportation & Transit",
      "poi_address": "2800 E Tropical Pkwy, North Las Vegas, NV 89081, USA",
      "poi_short_description": "Chain gas station with an ATM, a car wash, and a convenience store.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-c430-77ea-b61b-d38974771568.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-c430-77ea-b61b-d38974771568",
        "storage_key": "property/6767906449167863/01a1609f-c430-77ea-b61b-d38974771568.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://find.shell.com/us/fuel/10047634-2800-e-tropical-pkwy/en_US",
      "poi_directions_map_url": "https://maps.google.com/?cid=15793395095280288677&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shell",
      "poi_latitude": "36.2687224",
      "poi_longitude": "-115.1108803",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 702-754-1959",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a160a0-0119-770c-a786-47477055f425.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a160a0-0119-770c-a786-47477055f425",
        "storage_key": "property/6767906449167863/01a160a0-0119-770c-a786-47477055f425.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJh6kQW2_oyIARpQOUgylpLds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_9dc63157-ddc2-4af8-9f21-e4ccac6fe1dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "John Tartan Elementary School",
      "poi_type": "Education",
      "poi_address": "3030 E Tropical Pkwy, North Las Vegas, NV 89081, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-c433-712d-9276-2a1ea0685af0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-c433-712d-9276-2a1ea0685af0",
        "storage_key": "property/6767906449167863/01a1609f-c433-712d-9276-2a1ea0685af0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tartanes.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4927850797995085906&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-tartan-elementary-school",
      "poi_latitude": "36.270004799999995",
      "poi_longitude": "-115.106339",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 702-799-4701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-77a8-715a-8e92-8659e8543a28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-77a8-715a-8e92-8659e8543a28",
        "storage_key": "property/6767906449167863/01a16095-77a8-715a-8e92-8659e8543a28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjeIM_W_oyIARUlCfIDE-Y0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ad879dea-76d0-45be-994b-9cc90a7b394d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Jesse D. Scott Elementary School",
      "poi_type": "Education",
      "poi_address": "5700 Bruce St, North Las Vegas, NV 89081, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-c61f-713f-a3a0-ac8f3ac1286f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-c61f-713f-a3a0-ac8f3ac1286f",
        "storage_key": "property/6767906449167863/01a1609f-c61f-713f-a3a0-ac8f3ac1286f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jessedscottes.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3579425002509467928&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jesse-d-scott-elementary-school",
      "poi_latitude": "36.2644922",
      "poi_longitude": "-115.1244426",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 702-799-1766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-77a8-715a-8e92-8659e8543a28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-77a8-715a-8e92-8659e8543a28",
        "storage_key": "property/6767906449167863/01a16095-77a8-715a-8e92-8659e8543a28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy15WkUToyIARGIG6PhOsrDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_6a76ae98-2647-4eb3-98dc-7dd4ce86d893",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "D L Dusty Dickens Elementary School",
      "poi_type": "Education",
      "poi_address": "5550 Milan Peak St, North Las Vegas, NV 89081, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-c4a8-70d8-b60b-42fce54adc93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-c4a8-70d8-b60b-42fce54adc93",
        "storage_key": "property/6767906449167863/01a1609f-c4a8-70d8-b60b-42fce54adc93.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dickenselementary.org/#",
      "poi_directions_map_url": "https://maps.google.com/?cid=6716326216929361535&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "d-l-dusty-dickens-elementary-school",
      "poi_latitude": "36.2606468",
      "poi_longitude": "-115.09074269999998",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 702-799-3878",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-77a8-715a-8e92-8659e8543a28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-77a8-715a-8e92-8659e8543a28",
        "storage_key": "property/6767906449167863/01a16095-77a8-715a-8e92-8659e8543a28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ-PxBeHnyIARf763ExwvNV0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_73e151f3-f33f-414f-945f-74d5fa59fa2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Carroll M Johnston Middle School",
      "poi_type": "Education",
      "poi_address": "5855 N Lawrence St, North Las Vegas, NV 89081, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-c757-70c3-80ba-2aedc80f9379.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-c757-70c3-80ba-2aedc80f9379",
        "storage_key": "property/6767906449167863/01a1609f-c757-70c3-80ba-2aedc80f9379.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.johnstonbulldogs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7653764813140768313&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carroll-m-johnston-middle-school",
      "poi_latitude": "36.2663036",
      "poi_longitude": "-115.12215409999996",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 702-799-7001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-77a8-715a-8e92-8659e8543a28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-77a8-715a-8e92-8659e8543a28",
        "storage_key": "property/6767906449167863/01a16095-77a8-715a-8e92-8659e8543a28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1ousVzoyIARObaj0YuiN2o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_3a870b75-f8f8-4052-9fd7-b1e42a613384",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Clifford O Findlay Middle School",
      "poi_type": "Education",
      "poi_address": "333 W Tropical Pkwy, North Las Vegas, NV 89031, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-ca72-71c8-87cb-875092b07e3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-ca72-71c8-87cb-875092b07e3a",
        "storage_key": "property/6767906449167863/01a1609f-ca72-71c8-87cb-875092b07e3a.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://fmsflyers.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10655155465339000793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clifford-o-findlay-middle-school",
      "poi_latitude": "36.2679435",
      "poi_longitude": "-115.1453203",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 702-799-3160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-77a8-715a-8e92-8659e8543a28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-77a8-715a-8e92-8659e8543a28",
        "storage_key": "property/6767906449167863/01a16095-77a8-715a-8e92-8659e8543a28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJheES7avpyIAR2dcXOnG33pM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_5f436970-18c7-4205-bddc-aba942053eed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Somerset Academy | Losee Campus",
      "poi_type": "Education",
      "poi_address": "4650 Losee Rd, North Las Vegas, NV 89081, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-c8dc-76a5-ba02-916c249daeae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-c8dc-76a5-ba02-916c249daeae",
        "storage_key": "property/6767906449167863/01a1609f-c8dc-76a5-ba02-916c249daeae.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.somersetlosee.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13771372264051996139&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "somerset-academy--losee-campus",
      "poi_latitude": "36.2442132",
      "poi_longitude": "-115.11480939999998",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 702-826-4373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-77a8-715a-8e92-8659e8543a28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-77a8-715a-8e92-8659e8543a28",
        "storage_key": "property/6767906449167863/01a16095-77a8-715a-8e92-8659e8543a28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8X12xBjoyIAR63V8PBy-Hb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_aa77bd00-790e-4ee5-b0bd-95b892b3f73e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "East Centennial KinderCare",
      "poi_type": "Education",
      "poi_address": "651 E Centennial Pkwy, North Las Vegas, NV 89081, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-c7d2-7772-acf9-9b5d970e5252.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-c7d2-7772-acf9-9b5d970e5252",
        "storage_key": "property/6767906449167863/01a1609f-c7d2-7772-acf9-9b5d970e5252.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/north-las-vegas/nv/301947?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_MTg0ODAwNjUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3037904449375083815&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-centennial-kindercare",
      "poi_latitude": "36.2757326",
      "poi_longitude": "-115.13416399999998",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 702-445-7636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-77a8-715a-8e92-8659e8543a28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-77a8-715a-8e92-8659e8543a28",
        "storage_key": "property/6767906449167863/01a16095-77a8-715a-8e92-8659e8543a28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMWnpNzfpyIARJ52UTgDOKCo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_ed6ee7a8-d02d-4f6a-a894-251c7ff6d22a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "La Petite Academy on Simmons St",
      "poi_type": "Education",
      "poi_address": "4425 Simmons St, North Las Vegas, NV 89031, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-cb05-7581-bd9f-93efcde29dfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-cb05-7581-bd9f-93efcde29dfa",
        "storage_key": "property/6767906449167863/01a1609f-cb05-7581-bd9f-93efcde29dfa.webp",
        "width": 640,
        "height": 481
      },
      "poi_business_url": "https://www.lapetite.com/your-local-school/north-las-vegas-nv-7307/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=7307",
      "poi_directions_map_url": "https://maps.google.com/?cid=7012577053040856718&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-petite-academy-on-simmons-st",
      "poi_latitude": "36.2403753",
      "poi_longitude": "-115.18066419999998",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 877-271-6466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-77a8-715a-8e92-8659e8543a28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-77a8-715a-8e92-8659e8543a28",
        "storage_key": "property/6767906449167863/01a16095-77a8-715a-8e92-8659e8543a28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu5TNr_PpyIARjk6O7qytUWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_7455f14f-5750-4b7b-8a76-2ef2ba314f51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "College of Southern Nevada - North Las Vegas Campus",
      "poi_type": "Education",
      "poi_address": "3200 E Cheyenne Ave, North Las Vegas, NV 89030, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-49e0-700d-a453-791834cca68d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a16095-49e0-700d-a453-791834cca68d",
        "storage_key": "property/6767906449167863/01a16095-49e0-700d-a453-791834cca68d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.csn.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14232194105889914568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "college-of-southern-nevada---north-las-vegas-campus",
      "poi_latitude": "36.2200944",
      "poi_longitude": "-115.1046979",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 702-651-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-77a8-715a-8e92-8659e8543a28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-77a8-715a-8e92-8659e8543a28",
        "storage_key": "property/6767906449167863/01a16095-77a8-715a-8e92-8659e8543a28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ983J5rfCyIARyP75RyLpgsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_4788d448-3938-48a9-a8fe-995917e57eee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Legacy High School",
      "poi_type": "Education",
      "poi_address": "150 W Deer Springs Way, North Las Vegas, NV 89084, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-cd2d-70b9-948c-ca552ede3701.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-cd2d-70b9-948c-ca552ede3701",
        "storage_key": "property/6767906449167863/01a1609f-cd2d-70b9-948c-ca552ede3701.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://legacyhigh.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16975111133849582477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legacy-high-school",
      "poi_latitude": "36.284654",
      "poi_longitude": "-115.1413822",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 702-799-1777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-77a8-715a-8e92-8659e8543a28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-77a8-715a-8e92-8659e8543a28",
        "storage_key": "property/6767906449167863/01a16095-77a8-715a-8e92-8659e8543a28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq52lth3pyIARjfvhY6O1k-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_646885d3-2bea-4385-acb1-c231fbb68852",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Regal Aliante",
      "poi_type": "Entertainment",
      "poi_address": "7300 N Aliante Pkwy, North Las Vegas, NV 89084, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-d00c-73c5-b98a-ff37c8469862.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-d00c-73c5-b98a-ff37c8469862",
        "storage_key": "property/6767906449167863/01a1609f-d00c-73c5-b98a-ff37c8469862.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-aliante-1933?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=971894262157097171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-aliante",
      "poi_latitude": "36.292843",
      "poi_longitude": "-115.17884",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a160a0-0131-712a-b2b4-452684439fd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a160a0-0131-712a-b2b4-452684439fd7",
        "storage_key": "property/6767906449167863/01a160a0-0131-712a-b2b4-452684439fd7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJN-nO81rpyIAR0zgdn67cfA0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_14adde91-a9e7-45e9-aaaf-8667f3dcaa42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Aliante Nature Discovery Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2627 Nature Park Dr, North Las Vegas, NV 89084, USA",
      "poi_short_description": "20-acre park with tennis & volleyball courts plus a lake, waterfall & dinosaur-themed kids area.",
      "poi_long_description": "20-acre park with tennis & volleyball courts plus a lake, waterfall & dinosaur-themed kids area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-6129-715e-9c69-651595fc1916.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a16095-6129-715e-9c69-651595fc1916",
        "storage_key": "property/6767906449167863/01a16095-6129-715e-9c69-651595fc1916.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://cityofnorthlasvegas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=331761650938497891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aliante-nature-discovery-park",
      "poi_latitude": "36.286863",
      "poi_longitude": "-115.1759568",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-778a-75c9-a79e-84df926da316.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-778a-75c9-a79e-84df926da316",
        "storage_key": "property/6767906449167863/01a16095-778a-75c9-a79e-84df926da316.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvXjKyELpyIARY0tJunanmgQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ed89c45a-237b-445e-9566-e9bf4c990a40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Craig Ranch Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "628 W Craig Rd, North Las Vegas, NV 89032, USA",
      "poi_short_description": "Park offering grass lawns, playgrounds & sports areas on the site of a former golf course.",
      "poi_long_description": "Park offering grass lawns, playgrounds & sports areas on the site of a former golf course.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-5e88-742a-8fff-8fae0d8e302a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a16095-5e88-742a-8fff-8fae0d8e302a",
        "storage_key": "property/6767906449167863/01a16095-5e88-742a-8fff-8fae0d8e302a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofnorthlasvegas.com/things-to-do/parks-and-recreation/parks/craig-ranch-regional-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15417838234487929156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "craig-ranch-regional-park",
      "poi_latitude": "36.2434428",
      "poi_longitude": "-115.1500008",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 702-633-2418",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-778a-75c9-a79e-84df926da316.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-778a-75c9-a79e-84df926da316",
        "storage_key": "property/6767906449167863/01a16095-778a-75c9-a79e-84df926da316.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVfWq887pyIARRLkW4y8q99U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_36ef1434-92c2-4f54-b241-4aa45edc20f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Las Vegas Motor Speedway",
      "poi_type": "Entertainment",
      "poi_address": "7000 Las Vegas Blvd N, Las Vegas, NV 89115, USA",
      "poi_short_description": "Massive facility hosting NASCAR, drag racing & special events, plus fan racing experiences & tours.",
      "poi_long_description": "Massive facility hosting NASCAR, drag racing & special events, plus fan racing experiences & tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-d3cd-7455-8759-fdf384890176.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-d3cd-7455-8759-fdf384890176",
        "storage_key": "property/6767906449167863/01a1609f-d3cd-7455-8759-fdf384890176.webp",
        "width": 1280,
        "height": 692
      },
      "poi_business_url": "https://www.lvms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17678412730354683436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "las-vegas-motor-speedway",
      "poi_latitude": "36.2733573",
      "poi_longitude": "-115.01144130000002",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 702-644-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a160a0-0130-727d-9dbb-60ed39dbd190.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a160a0-0130-727d-9dbb-60ed39dbd190",
        "storage_key": "property/6767906449167863/01a160a0-0130-727d-9dbb-60ed39dbd190.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQTLJVDnyIARLM6IybZWVvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "race_course"
    },
    {
      "id": "custom_8c082a9a-82f1-4a69-99fd-d55476d7a6ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Cannery Casino & Hotel",
      "poi_type": "Entertainment",
      "poi_address": "2121 E Craig Rd, North Las Vegas, NV 89030, USA",
      "poi_short_description": "Low-key casino hotel with traditional rooms, several bars & eateries, a pool & live shows.",
      "poi_long_description": "Low-key casino hotel with traditional rooms, several bars & eateries, a pool & live shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-cff7-761b-b14c-64e321a2d2c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-cff7-761b-b14c-64e321a2d2c5",
        "storage_key": "property/6767906449167863/01a1609f-cff7-761b-b14c-64e321a2d2c5.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://cannery.boydgaming.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4368736946464377409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cannery-casino--hotel",
      "poi_latitude": "36.238521",
      "poi_longitude": "-115.118824",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 702-507-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a160a0-0190-76b8-86f8-cf373b74ea84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a160a0-0190-76b8-86f8-cf373b74ea84",
        "storage_key": "property/6767906449167863/01a160a0-0190-76b8-86f8-cf373b74ea84.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJxYriRSDoyIARQUoiMxvfoDw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_f81190e0-f8f3-43e6-941d-922ba1e3add1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "West Wind Las Vegas Drive-In",
      "poi_type": "Entertainment",
      "poi_address": "4150 W Carey Ave, North Las Vegas, NV 89032, USA",
      "poi_short_description": "This retro drive-in movie theater screens the latest releases & pipes sound into cars via FM radio.",
      "poi_long_description": "This retro drive-in movie theater screens the latest releases & pipes sound into cars via FM radio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-d374-7448-9063-3f83b2af72ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-d374-7448-9063-3f83b2af72ca",
        "storage_key": "property/6767906449167863/01a1609f-d374-7448-9063-3f83b2af72ca.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.westwinddi.com/locations/las-vegas",
      "poi_directions_map_url": "https://maps.google.com/?cid=3528245262301860989&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-wind-las-vegas-drive-in",
      "poi_latitude": "36.205292199999995",
      "poi_longitude": "-115.1962251",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 702-646-3565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a160a0-0131-712a-b2b4-452684439fd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a160a0-0131-712a-b2b4-452684439fd7",
        "storage_key": "property/6767906449167863/01a160a0-0131-712a-b2b4-452684439fd7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJjSTPd_TByIARfRT1Y1_Y9jA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_80dc26b1-6072-46f7-a405-8adbe34cc0f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Galaxy Theatres Boulevard Mall",
      "poi_type": "Entertainment",
      "poi_address": "3680 S Maryland Pkwy Ste 182, Las Vegas, NV 89169, USA",
      "poi_short_description": "Modern movie theater featuring luxury reclining seats and premium cinema dining with beer and wine.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-d25c-74ec-a8fb-f733eab8ac05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-d25c-74ec-a8fb-f733eab8ac05",
        "storage_key": "property/6767906449167863/01a1609f-d25c-74ec-a8fb-f733eab8ac05.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.galaxytheatres.com/movie-theater/boulevardmall",
      "poi_directions_map_url": "https://maps.google.com/?cid=16055387863634349114&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "galaxy-theatres-boulevard-mall",
      "poi_latitude": "36.1237329",
      "poi_longitude": "-115.13483309999998",
      "poi_miles_from_property": "11.9",
      "poi_walking_minutes": "4 hours 30 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 888-407-9874",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a160a0-0131-712a-b2b4-452684439fd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a160a0-0131-712a-b2b4-452684439fd7",
        "storage_key": "property/6767906449167863/01a160a0-0131-712a-b2b4-452684439fd7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJQfgIF7jFyIAROgwLZzIy0N4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_a394a091-dfbf-4481-b6a9-68fcf83d52cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "The Neon Museum Las Vegas",
      "poi_type": "Entertainment",
      "poi_address": "770 Las Vegas Blvd N, Las Vegas, NV 89101, USA",
      "poi_short_description": "Guided tours of a collection of Vegas signage, some from famous landmarks, from the 1930s to today.",
      "poi_long_description": "Guided tours of a collection of Vegas signage, some from famous landmarks, from the 1930s to today.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-d2c4-7496-943c-b0715b1d1271.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-d2c4-7496-943c-b0715b1d1271",
        "storage_key": "property/6767906449167863/01a1609f-d2c4-7496-943c-b0715b1d1271.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.neonmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15662440221974327191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-neon-museum-las-vegas",
      "poi_latitude": "36.1769882",
      "poi_longitude": "-115.13533739999998",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 702-387-6366",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a160a0-0191-75f9-97d5-c5cd84d35132.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a160a0-0191-75f9-97d5-c5cd84d35132",
        "storage_key": "property/6767906449167863/01a160a0-0191-75f9-97d5-c5cd84d35132.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJcZcZBAzDyIARl--REmYqXNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_51eb75dd-d607-4feb-bd79-fc056973f724",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "The Mob Museum",
      "poi_type": "Entertainment",
      "poi_address": "300 Stewart Ave, Las Vegas, NV 89101, USA",
      "poi_short_description": "Interactive exhibits in historic courthouse tell stories of Mob's rise & law enforcement's response.",
      "poi_long_description": "Interactive exhibits in historic courthouse tell stories of Mob's rise & law enforcement's response.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-d957-745f-ba59-be88d664d567.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-d957-745f-ba59-be88d664d567",
        "storage_key": "property/6767906449167863/01a1609f-d957-745f-ba59-be88d664d567.webp",
        "width": 1280,
        "height": 898
      },
      "poi_business_url": "https://themobmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6140054583531483805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-mob-museum",
      "poi_latitude": "36.1728198",
      "poi_longitude": "-115.1412395",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 702-229-2734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a160a0-0191-75f9-97d5-c5cd84d35132.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a160a0-0191-75f9-97d5-c5cd84d35132",
        "storage_key": "property/6767906449167863/01a160a0-0191-75f9-97d5-c5cd84d35132.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dSwgwrDyIARnTLnwBzbNVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_453407a0-0aa9-4770-a8e1-282060c18e30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "The Adventuredome Indoor Theme Park",
      "poi_type": "Entertainment",
      "poi_address": "2880 S Las Vegas Blvd, Las Vegas, NV 89109, USA",
      "poi_short_description": "Climate-controlled amusement park featuring rides, arcade, midway games & miniature golf.",
      "poi_long_description": "Climate-controlled amusement park featuring rides, arcade, midway games & miniature golf.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-d9b3-77f7-9c97-92b6185af62c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-d9b3-77f7-9c97-92b6185af62c",
        "storage_key": "property/6767906449167863/01a1609f-d9b3-77f7-9c97-92b6185af62c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8604766050360282781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-adventuredome-indoor-theme-park",
      "poi_latitude": "36.1380193",
      "poi_longitude": "-115.16665890000002",
      "poi_miles_from_property": "11.3",
      "poi_walking_minutes": "4 hours 17 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 702-794-3939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a160a0-0190-76b8-86f8-cf373b74ea84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a160a0-0190-76b8-86f8-cf373b74ea84",
        "storage_key": "property/6767906449167863/01a160a0-0190-76b8-86f8-cf373b74ea84.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJmSto3AzEyIARnc4Q_yFFanc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_43386248-8240-4052-a556-d44ea1fce821",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "North Vista Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1409 E Lake Mead Blvd, North Las Vegas, NV 89030, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-d8e1-735f-ba2c-01602ca242ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-d8e1-735f-ba2c-01602ca242ed",
        "storage_key": "property/6767906449167863/01a1609f-d8e1-735f-ba2c-01602ca242ed.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://northvistahospital.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp_main",
      "poi_directions_map_url": "https://maps.google.com/?cid=8768311887015640786&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-vista-hospital",
      "poi_latitude": "36.1950921",
      "poi_longitude": "-115.1228645",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 702-649-7711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7789-72b8-a159-2854f3ffbc02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7789-72b8-a159-2854f3ffbc02",
        "storage_key": "property/6767906449167863/01a16095-7789-72b8-a159-2854f3ffbc02.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJworIx7DyIAR0v5maTRNr3k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_210525b3-22df-4120-b51c-41ad81d0435b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "North Las Vegas VA Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "Bldg. 5, 6900 N Pecos Rd, North Las Vegas, NV 89086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-db9a-7534-8f81-fba37123300f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-db9a-7534-8f81-fba37123300f",
        "storage_key": "property/6767906449167863/01a1609f-db9a-7534-8f81-fba37123300f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lasvegas.va.gov/locations/directions.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=8812144716623489337&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-las-vegas-va-medical-center",
      "poi_latitude": "36.2859308",
      "poi_longitude": "-115.092762",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 702-791-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7789-72b8-a159-2854f3ffbc02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7789-72b8-a159-2854f3ffbc02",
        "storage_key": "property/6767906449167863/01a16095-7789-72b8-a159-2854f3ffbc02.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJFxhjiirmyIAROamtV-4GS3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0eae9b93-46d1-4971-b1e6-14f1ac3db656",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "UMC Quick Care - Aliante",
      "poi_type": "Health and Wellness",
      "poi_address": "5860 Losee Rd, North Las Vegas, NV 89081, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-dffb-74e3-afc5-a850b859fa1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-dffb-74e3-afc5-a850b859fa1e",
        "storage_key": "property/6767906449167863/01a1609f-dffb-74e3-afc5-a850b859fa1e.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://umcsn.com/quickcare",
      "poi_directions_map_url": "https://maps.google.com/?cid=5208021530601010656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "umc-quick-care---aliante",
      "poi_latitude": "36.266393",
      "poi_longitude": "-115.1162366",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 702-383-3910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7787-7121-8457-f0ba674ae9ff",
        "storage_key": "property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhb0nB1TpyIAR4DUPIv2bRkg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_588e8a1d-1cc0-4be6-926d-d821962bf37b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "ER at Aliante",
      "poi_type": "Health and Wellness",
      "poi_address": "7207 N Aliante Pkwy, North Las Vegas, NV 89084, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-dcce-7026-8275-e3073afd32ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-dcce-7026-8275-e3073afd32ce",
        "storage_key": "property/6767906449167863/01a1609f-dcce-7026-8275-e3073afd32ce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sunrisehealthinfo.com/locations/er-at-aliante?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11377428106665748629&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "er-at-aliante",
      "poi_latitude": "36.2907797",
      "poi_longitude": "-115.18248659999998",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 702-962-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7787-7121-8457-f0ba674ae9ff",
        "storage_key": "property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp3j_DbXpyIARlWhbM5W-5J0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_5aa1181b-8e4c-44d0-b0fb-6b65b9f19bb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "CareNow Urgent Care - Aliante",
      "poi_type": "Health and Wellness",
      "poi_address": "560 E Deer Springs Way, North Las Vegas, NV 89086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-e321-751c-b616-490aa914eefe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-e321-751c-b616-490aa914eefe",
        "storage_key": "property/6767906449167863/01a1609f-e321-751c-b616-490aa914eefe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.carenow.com/locations/las-vegas/aliante?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3275290223803745134&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---aliante",
      "poi_latitude": "36.2839621",
      "poi_longitude": "-115.1341117",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 725-228-4895",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7787-7121-8457-f0ba674ae9ff",
        "storage_key": "property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-SjUq1zpyIARbsMh9hordC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_093a88bf-8da6-45d7-9382-5e3eb5c05551",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Smith's Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "6855 N Aliante Pkwy, North Las Vegas, NV 89084, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-e1d7-75a3-b188-a28b165c0315.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-e1d7-75a3-b188-a28b165c0315",
        "storage_key": "property/6767906449167863/01a1609f-e1d7-75a3-b188-a28b165c0315.webp",
        "width": 1280,
        "height": 706
      },
      "poi_business_url": "https://www.smithsfoodanddrug.com/rx/pharmacy/details/706/00338?cid=loc_70600338P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16082188707303426483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smiths-pharmacy",
      "poi_latitude": "36.285041199999995",
      "poi_longitude": "-115.1790547",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 702-642-6062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a160a0-0118-7629-ae54-2d9c65e0cd0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a160a0-0118-7629-ae54-2d9c65e0cd0a",
        "storage_key": "property/6767906449167863/01a160a0-0118-7629-ae54-2d9c65e0cd0a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ9czZl3pyIARs4meFWxpL98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_86e35e2f-7bd7-45a2-8bd1-1e82b003a15d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2745 W Centennial Pkwy Ste 115, North Las Vegas, NV 89084, USA",
      "poi_short_description": "Well-equipped gym offering fitness classes, personal training, and cinema cardio.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-4dbb-7021-8a36-8cf31c3ade13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a16095-4dbb-7021-8a36-8cf31c3ade13",
        "storage_key": "property/6767906449167863/01a16095-4dbb-7021-8a36-8cf31c3ade13.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/aliante/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8333769701716645934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "36.2762209",
      "poi_longitude": "-115.1779033",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 702-396-0800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7787-7121-8457-f0ba674ae9ff",
        "storage_key": "property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1YbfV_7oyIARLti7tmN_p3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ab4e22d2-40ad-4c2d-b349-b998e0d8cee5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Club Pilates Aliante",
      "poi_type": "Health and Wellness",
      "poi_address": "6905 N Aliante Pkwy Ste 104, North Las Vegas, NV 89084, USA",
      "poi_short_description": "Welcoming Pilates studio offering Reformer-based classes focused on strength and mobility.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-e2a6-7593-9dab-874a81950277.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-e2a6-7593-9dab-874a81950277",
        "storage_key": "property/6767906449167863/01a1609f-e2a6-7593-9dab-874a81950277.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.clubpilates.com/aliante/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=8486643659319805956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates-aliante",
      "poi_latitude": "36.2858831",
      "poi_longitude": "-115.1784945",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 702-342-8827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7787-7121-8457-f0ba674ae9ff",
        "storage_key": "property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlef2MRPpyIARBAgUqXGdxnU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_eddb9d69-dbe2-4356-a77c-9df0773612b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Tropical Breeze Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1505 E Tropical Pkwy, North Las Vegas, NV 89081, USA",
      "poi_short_description": "Family-friendly park featuring a splash pad, playground, and picnic areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-6538-73aa-b4af-418417f4c40c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a16095-6538-73aa-b4af-418417f4c40c",
        "storage_key": "property/6767906449167863/01a16095-6538-73aa-b4af-418417f4c40c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityofnorthlasvegas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4301164056179497533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tropical-breeze-park",
      "poi_latitude": "36.26717610000001",
      "poi_longitude": "-115.124595",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 702-633-1171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-778a-75c9-a79e-84df926da316.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-778a-75c9-a79e-84df926da316",
        "storage_key": "property/6767906449167863/01a16095-778a-75c9-a79e-84df926da316.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJP6wIRFvoyIARPdpBqevNsDs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e640a839-3342-48c3-82f4-f8e5cd0ee3fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Tule Springs Fossil Beds National Monument",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Las Vegas, NV 89124, USA",
      "poi_short_description": "Arid valley with prehistoric fossils of mammoths, lions & camels, plus rare Las Vegas bearpoppies.",
      "poi_long_description": "Arid valley with prehistoric fossils of mammoths, lions & camels, plus rare Las Vegas bearpoppies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-e5f4-72ea-b395-09db83be6e44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-e5f4-72ea-b395-09db83be6e44",
        "storage_key": "property/6767906449167863/01a1609f-e5f4-72ea-b395-09db83be6e44.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nps.gov/tusk/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14102001575140888894&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tule-springs-fossil-beds-national-monument",
      "poi_latitude": "36.3360724",
      "poi_longitude": "-115.2786103",
      "poi_miles_from_property": "14.8",
      "poi_walking_minutes": "5 hours 33 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 702-293-8853",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-778a-75c9-a79e-84df926da316.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-778a-75c9-a79e-84df926da316",
        "storage_key": "property/6767906449167863/01a16095-778a-75c9-a79e-84df926da316.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbZJC-jPtyIARPpFFjLdftMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "national_park"
    },
    {
      "id": "custom_09a24665-5bc3-4979-b902-9470026525d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Seastrand Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6330 Camino Eldorado Pkwy, North Las Vegas, NV 89031, USA",
      "poi_short_description": "Versatile community park featuring diverse sports facilities and a dedicated dog park.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-e56c-720e-b396-52c6a9ca46c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-e56c-720e-b396-52c6a9ca46c3",
        "storage_key": "property/6767906449167863/01a1609f-e56c-720e-b396-52c6a9ca46c3.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.cityofnorthlasvegas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16067159527065510851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seastrand-community-park",
      "poi_latitude": "36.2772418",
      "poi_longitude": "-115.1618773",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 702-633-1171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-778a-75c9-a79e-84df926da316.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-778a-75c9-a79e-84df926da316",
        "storage_key": "property/6767906449167863/01a16095-778a-75c9-a79e-84df926da316.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7eLQCg3pyIARw-NFYHYE-t4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_11a9bbfb-a365-4852-b93b-19ebab43b673",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Hartke Skatepark",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1700 N Bruce St, North Las Vegas, NV 89030, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-e775-7268-9fae-5ea7c2acaceb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-e775-7268-9fae-5ea7c2acaceb",
        "storage_key": "property/6767906449167863/01a1609f-e775-7268-9fae-5ea7c2acaceb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2555922298741315906&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hartke-skatepark",
      "poi_latitude": "36.190376",
      "poi_longitude": "-115.1234629",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7787-7121-8457-f0ba674ae9ff",
        "storage_key": "property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2cp8SjTDyIARQtn58cl1eCM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "skateboard_park"
    },
    {
      "id": "custom_c3ea1b27-641b-4a16-b060-a92efce8d1b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Prentiss Walker Memorial Park and Pool",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1509 June Ave, North Las Vegas, NV 89032, USA",
      "poi_short_description": "Park with picnic areas, barbecue grills, a restroom, and a playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-e8fd-7732-a61a-c8ddf1694f60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-e8fd-7732-a61a-c8ddf1694f60",
        "storage_key": "property/6767906449167863/01a1609f-e8fd-7732-a61a-c8ddf1694f60.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.cityofnorthlasvegas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14748502754142226449&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prentiss-walker-memorial-park-and-pool",
      "poi_latitude": "36.2082611",
      "poi_longitude": "-115.16143059999996",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-778a-75c9-a79e-84df926da316.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-778a-75c9-a79e-84df926da316",
        "storage_key": "property/6767906449167863/01a16095-778a-75c9-a79e-84df926da316.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJpTVdQWrCyIAREYiELR01rcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_972696db-ff16-4343-89f5-92e5834a09e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Nicholas E. Flores Jr.Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4133 Allen Ln, North Las Vegas, NV 89032, USA",
      "poi_short_description": "Community park featuring a children's play area and exercise equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-ece5-76f9-9b72-ef9d6e050ac8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-ece5-76f9-9b72-ef9d6e050ac8",
        "storage_key": "property/6767906449167863/01a1609f-ece5-76f9-9b72-ef9d6e050ac8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14449327508832785224&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nicholas-e-flores-jrpark",
      "poi_latitude": "36.2345213",
      "poi_longitude": "-115.1893824",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 702-633-2650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-778a-75c9-a79e-84df926da316.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-778a-75c9-a79e-84df926da316",
        "storage_key": "property/6767906449167863/01a16095-778a-75c9-a79e-84df926da316.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNyTswR3qyIARSBNCP9BShsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_86f0e155-f68c-423a-b9f0-b9bc03a4d333",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Petitti Pool",
      "poi_type": "Health and Wellness",
      "poi_address": "2505 N Bruce St, North Las Vegas, NV 89030, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cityofnorthlasvegas.com/things-to-do/pools",
      "poi_directions_map_url": "https://maps.google.com/?cid=14626650434181068387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "petitti-pool",
      "poi_latitude": "36.2051162",
      "poi_longitude": "-115.126117",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 702-633-2550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7787-7121-8457-f0ba674ae9ff",
        "storage_key": "property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGY3gGwDDyIARY_YsFxNN_Mo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "swimming_pool"
    },
    {
      "id": "custom_47594db3-3a19-45e1-b774-49d5a55e6919",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Kiel Ranch Historic Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2465 Kiel Way, North Las Vegas, NV 89030, USA",
      "poi_short_description": "Peaceful historic park offering scenic walking paths and picnic areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-e956-70b3-9458-f26b7d8f9f42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-e956-70b3-9458-f26b7d8f9f42",
        "storage_key": "property/6767906449167863/01a1609f-e956-70b3-9458-f26b7d8f9f42.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17853814354258721476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kiel-ranch-historic-park",
      "poi_latitude": "36.2044962",
      "poi_longitude": "-115.1409281",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-778a-75c9-a79e-84df926da316.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-778a-75c9-a79e-84df926da316",
        "storage_key": "property/6767906449167863/01a16095-778a-75c9-a79e-84df926da316.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1T-CnVjCyIARxHpcx499xfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c54c7cac-4226-4677-90ab-84e64ebea94c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "WB Tropicana after Pecos",
      "poi_type": "Transportation & Transit",
      "poi_address": "Paradise, NV 89121, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7992288526369832585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wb-tropicana-after-pecos",
      "poi_latitude": "36.1001741",
      "poi_longitude": "-115.10220689999998",
      "poi_miles_from_property": "12.7",
      "poi_walking_minutes": "4 hours 44 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a160a0-0131-712a-b2b4-43e517127b37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a160a0-0131-712a-b2b4-43e517127b37",
        "storage_key": "property/6767906449167863/01a160a0-0131-712a-b2b4-43e517127b37.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJTwKSWjbFyIARiT603BFQ6m4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_8044acb6-9fc2-4b3f-8fdf-acdb342bd327",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Blue Reef Aquatics",
      "poi_type": "Shopping & Retail",
      "poi_address": "5870 Losee Rd #154, North Las Vegas, NV 89081, USA",
      "poi_short_description": "Basic pet shop selling saltwater & freshwater fish, corals, supplies & more in aquarium-filled digs.",
      "poi_long_description": "Basic pet shop selling saltwater & freshwater fish, corals, supplies & more in aquarium-filled digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-edf2-71d1-839d-c2cea867c84b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-edf2-71d1-839d-c2cea867c84b",
        "storage_key": "property/6767906449167863/01a1609f-edf2-71d1-839d-c2cea867c84b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bluereefaquatics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18095702140955271715&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-reef-aquatics",
      "poi_latitude": "36.2666713",
      "poi_longitude": "-115.1166619",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 702-252-7333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7783-756c-99f2-01e35fe7e0f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7783-756c-99f2-01e35fe7e0f5",
        "storage_key": "property/6767906449167863/01a16095-7783-756c-99f2-01e35fe7e0f5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ63BQbmDoyIARIyLq2DjZIPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pet_store"
    },
    {
      "id": "custom_5806cb06-0044-453a-8bfb-af1a57e83b1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "WB Centennial after Pecos",
      "poi_type": "Transportation & Transit",
      "poi_address": "North Las Vegas, NV 89086, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-ed92-70a9-b9d3-fddb0d870fab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-ed92-70a9-b9d3-fddb0d870fab",
        "storage_key": "property/6767906449167863/01a1609f-ed92-70a9-b9d3-fddb0d870fab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7531131524058096923&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wb-centennial-after-pecos",
      "poi_latitude": "36.27668500000001",
      "poi_longitude": "-115.099407",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a160a0-05ed-749a-84c4-54085d3d2a07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a160a0-05ed-749a-84c4-54085d3d2a07",
        "storage_key": "property/6767906449167863/01a160a0-05ed-749a-84c4-54085d3d2a07.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ51TUnnoyIARG6U6MDj0g2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_cf281b0c-2143-4b74-8dd1-9bec0a6fd195",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Harry Reid International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5757 Wayne Newton Blvd, Las Vegas, NV 89119, USA",
      "poi_short_description": "Airport serving the Las Vegas area, with more than 1,200 slot machines.",
      "poi_long_description": "Airport serving the Las Vegas area, with more than 1,200 slot machines.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-f0c2-76c9-ae43-ece982361715.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-f0c2-76c9-ae43-ece982361715",
        "storage_key": "property/6767906449167863/01a1609f-f0c2-76c9-ae43-ece982361715.webp",
        "width": 1280,
        "height": 956
      },
      "poi_business_url": "https://www.harryreidairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5121535212920249886&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harry-reid-international-airport",
      "poi_latitude": "36.08309070000001",
      "poi_longitude": "-115.1482238",
      "poi_miles_from_property": "17.5",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "1 hour 37 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 702-261-5211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a160a0-061e-7664-a971-f2b2dda6c616.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a160a0-061e-7664-a971-f2b2dda6c616",
        "storage_key": "property/6767906449167863/01a160a0-061e-7664-a971-f2b2dda6c616.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJXZwEH5_FyIARHh7EHiRZE0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_08acd128-dbe8-420e-bf38-a487682a97eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "South Strip Transit Terminal",
      "poi_type": "Transportation & Transit",
      "poi_address": "6675 Gilespie St, Las Vegas, NV 89119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-eeb8-7664-9aae-8501b9d0353c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-eeb8-7664-9aae-8501b9d0353c",
        "storage_key": "property/6767906449167863/01a1609f-eeb8-7664-9aae-8501b9d0353c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rtcsnv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4498123267377459311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-strip-transit-terminal",
      "poi_latitude": "36.0684001",
      "poi_longitude": "-115.1650757",
      "poi_miles_from_property": "16.6",
      "poi_walking_minutes": "6 hours 19 mins",
      "poi_biking_minutes": "1 hour 46 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 702-228-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a160a0-0638-7001-96df-6179295a6742.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a160a0-0638-7001-96df-6179295a6742",
        "storage_key": "property/6767906449167863/01a160a0-0638-7001-96df-6179295a6742.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJEdj6wIzFyIARb_Dzk0eLbD4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_bf0f30b2-f278-4293-a3fc-55484d1edb4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Centennial Hills Park and Ride Lot 1",
      "poi_type": "Transportation & Transit",
      "poi_address": "7313 Grand Montecito Pkwy, Las Vegas, NV 89149, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-f321-7709-a25b-780a49be9fb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-f321-7709-a25b-780a49be9fb1",
        "storage_key": "property/6767906449167863/01a1609f-f321-7709-a25b-780a49be9fb1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10877025015692110563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-hills-park-and-ride-lot-1",
      "poi_latitude": "36.2937814",
      "poi_longitude": "-115.2847827",
      "poi_miles_from_property": "12.6",
      "poi_walking_minutes": "4 hours 47 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a160a0-0638-7001-96df-6179295a6742.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a160a0-0638-7001-96df-6179295a6742",
        "storage_key": "property/6767906449167863/01a160a0-0638-7001-96df-6179295a6742.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTzS6UyTyIAR46pdcZ_08pY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_3a3e0799-a12c-4359-aaa8-8b02512e8de2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Bonneville Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "101 E Bonneville Ave, Las Vegas, NV 89101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-f505-7317-ab87-43188cd18f5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-f505-7317-ab87-43188cd18f5a",
        "storage_key": "property/6767906449167863/01a1609f-f505-7317-ab87-43188cd18f5a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11988010772021509434&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonneville-transit-center",
      "poi_latitude": "36.1647038",
      "poi_longitude": "-115.14900929999996",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 800-228-3911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7787-7121-8457-f0ba674ae9ff",
        "storage_key": "property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAaqD1z7DyIAROv3lLUj4XaY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_da401c0a-448d-49ee-be66-335ec8f3b736",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Amazon Fulfillment Center VGT1",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5802 E Tropical Pkwy, Las Vegas, NV 89115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-f639-72fe-a8e3-dbe3d8db7569.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-f639-72fe-a8e3-dbe3d8db7569",
        "storage_key": "property/6767906449167863/01a1609f-f639-72fe-a8e3-dbe3d8db7569.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11738630151346492134&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amazon-fulfillment-center-vgt1",
      "poi_latitude": "36.2711507",
      "poi_longitude": "-115.0447718",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7787-7121-8457-f0ba674ae9ff",
        "storage_key": "property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnw0A_MDnyIAR5pKywO3956I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_33d2c163-3928-4ac5-8847-9b49360cc31b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Amazon Fulfillment Center LAS6",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4550 Nexus Wy, North Las Vegas, NV 89081, USA",
      "poi_short_description": "Large-scale fulfillment center specializing in non-sortable inventory and equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-f4fd-717d-9540-deb9d8631baf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-f4fd-717d-9540-deb9d8631baf",
        "storage_key": "property/6767906449167863/01a1609f-f4fd-717d-9540-deb9d8631baf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amazon.jobs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14174395613650575992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amazon-fulfillment-center-las6",
      "poi_latitude": "36.2668919",
      "poi_longitude": "-115.0743905",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 855-556-5208",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7787-7121-8457-f0ba674ae9ff",
        "storage_key": "property/6767906449167863/01a16095-7787-7121-8457-f0ba674ae9ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY4whPOnnyIAReGJ_IbaRtcQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_1112242d-9832-437f-8f0f-7c5552dfe9e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Nellis Mental Health",
      "poi_type": "Health and Wellness",
      "poi_address": "3411 Carswell Ave, Nellis AFB, NV 89191, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://nellis.tricare.mil/Health-Services/Mental-Health-Substance-Abuse/Mental-Health",
      "poi_directions_map_url": "https://maps.google.com/?cid=9360856789198366090&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nellis-mental-health",
      "poi_latitude": "36.2382487",
      "poi_longitude": "-115.0452933",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 702-653-3880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7760-771c-946a-1ed072ce9cdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7760-771c-946a-1ed072ce9cdb",
        "storage_key": "property/6767906449167863/01a16095-7760-771c-946a-1ed072ce9cdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv5D_4J3dyIARiuV4Yadx6IE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_aa0f0e0b-23b6-4c57-b31f-cebd9081dbde",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "University Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1800 W Charleston Blvd, Las Vegas, NV 89102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-f7b6-7056-95cf-df92875b60c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-f7b6-7056-95cf-df92875b60c7",
        "storage_key": "property/6767906449167863/01a1609f-f7b6-7056-95cf-df92875b60c7.webp",
        "width": 1280,
        "height": 782
      },
      "poi_business_url": "https://www.umcsn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18346410434570994005&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-medical-center",
      "poi_latitude": "36.1603396",
      "poi_longitude": "-115.1675578",
      "poi_miles_from_property": "10.1",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 702-383-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7789-72b8-a159-2854f3ffbc02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7789-72b8-a159-2854f3ffbc02",
        "storage_key": "property/6767906449167863/01a16095-7789-72b8-a159-2854f3ffbc02.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJwZbBe-vDyIARVcEfOBaLm_4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d00b8bb1-b327-49f4-a9ea-940b223b0f96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Sunrise Hospital and Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3186 S Maryland Pkwy, Las Vegas, NV 89109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-f82d-703e-9dd1-ffdc0e95ecc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-f82d-703e-9dd1-ffdc0e95ecc6",
        "storage_key": "property/6767906449167863/01a1609f-f82d-703e-9dd1-ffdc0e95ecc6.webp",
        "width": 888,
        "height": 499
      },
      "poi_business_url": "https://www.sunrisehealthinfo.com/locations/sunrise-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1837394935718176733&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunrise-hospital-and-medical-center",
      "poi_latitude": "36.132715399999995",
      "poi_longitude": "-115.1358324",
      "poi_miles_from_property": "11.3",
      "poi_walking_minutes": "4 hours 17 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 702-961-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7789-72b8-a159-2854f3ffbc02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7789-72b8-a159-2854f3ffbc02",
        "storage_key": "property/6767906449167863/01a16095-7789-72b8-a159-2854f3ffbc02.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ23WFiIvEyIAR3WeVh_W8fxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_3172b75d-b027-43d6-8478-13946bc1a805",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "Centennial Hills Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6900 N Durango Dr, Las Vegas, NV 89149, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a1609f-f998-73cd-9af7-257b904350ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1609f-f998-73cd-9af7-257b904350ac",
        "storage_key": "property/6767906449167863/01a1609f-f998-73cd-9af7-257b904350ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.centennialhillshospital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4193994053116637256&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-hills-hospital",
      "poi_latitude": "36.2871043",
      "poi_longitude": "-115.2860446",
      "poi_miles_from_property": "12.6",
      "poi_walking_minutes": "4 hours 48 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 702-835-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7789-72b8-a159-2854f3ffbc02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7789-72b8-a159-2854f3ffbc02",
        "storage_key": "property/6767906449167863/01a16095-7789-72b8-a159-2854f3ffbc02.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ1-wi1OTyIARSDAe3l4PNDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_ce1bf256-b9c2-4566-9999-df19e575b63b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "custom",
      "poi_name": "North Las Vegas City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2250 Las Vegas Blvd N, North Las Vegas, NV 89030, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-6a31-7119-8384-348902a4ceaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a16095-6a31-7119-8384-348902a4ceaf",
        "storage_key": "property/6767906449167863/01a16095-6a31-7119-8384-348902a4ceaf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityofnorthlasvegas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7676801457851576574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-las-vegas-city-hall",
      "poi_latitude": "36.2004531",
      "poi_longitude": "-115.1211472",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 702-633-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16095-7760-771c-946a-1ed072ce9cdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a16095-7760-771c-946a-1ed072ce9cdb",
        "storage_key": "property/6767906449167863/01a16095-7760-771c-946a-1ed072ce9cdb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC33Dl6LBJRUR_rBxokB6iWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    }
  ],
  "office_hours": [
    {
      "id": "ec_136eb92063d009dde263c1ce",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_337c21b05722ed95d4fd934e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_af2d225bd311256b179c5849",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_b1c4f50ebdcbb0db2e26396a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_33019ee52641ab1ff044c059",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [],
  "virtual_tours": [],
  "faqs": [],
  "pet_policies": [
    {
      "id": "ec_2fe3c56ebba9bcaa7cc05e50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "yardi",
      "external_id": "2945475",
      "pet_type": "all",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 350,
      "fee": 0,
      "monthly_rent": 40,
      "description": "false",
      "restrictions": "false"
    },
    {
      "id": "ec_8427ab484dcbadc37ab6c30d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863",
      "source": "yardi",
      "external_id": "2945476",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 0,
      "description": "false",
      "restrictions": "false"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a18868-bff5-7559-82db-1fdc3afa6c90",
      "lead_source": "LANDING_PAGE",
      "name": "Prosper 207 Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863"
    },
    {
      "lead_collector_id": "01a18868-c14a-712a-ad20-3fd002655f75",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Prosper 207 Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162469",
      "property_id": "6767906449167863"
    }
  ],
  "hyperlocal_queries": [],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "allison@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "13315896499"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-M3F9V9K9"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Blue Haven"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "725-338-5941"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlVRWEJUcTRyWFZManNXVjFTOE9EUHc9PSIsInZhbHVlIjoiS2Yxcld0TTJqNS9wclpIM1ZnS1lwdz09IiwibWFjIjoiNmI4ZTU1ZWIzMWZkNDZmZGYwNzAwNGM5ZjkzOTBkNTljM2I5OTQ0YTlhMzMzZjMyM2MxYjBjZGRjODQ5NDBhYyJ9"
    }
  ],
  "custom_csm": "allison@repli360.com",
  "custom_repli_id": "13315896499",
  "custom_google_gtm_id": "GTM-M3F9V9K9",
  "custom_vibesites_theme": "Blue Haven",
  "custom_ads_subscription": "essential",
  "custom_seo_subscription": "full_stack",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "725-338-5941",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlVRWEJUcTRyWFZManNXVjFTOE9EUHc9PSIsInZhbHVlIjoiS2Yxcld0TTJqNS9wclpIM1ZnS1lwdz09IiwibWFjIjoiNmI4ZTU1ZWIzMWZkNDZmZGYwNzAwNGM5ZjkzOTBkNTljM2I5OTQ0YTlhMzMzZjMyM2MxYjBjZGRjODQ5NDBhYyJ9",
  "custom_audioeye_site_id": "0724b9c3-4dde-4476-b21f-43c3b57491b1",
  "custom_audioeye_site_hash": "2ce2828ebf66b92a584f615d684a067a"
};

export const generatedAt = '2026-11-04T21:37:37.106Z';
